import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { paramsDoDetalhe } from "../pages/revenue/categoriaDaV2";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useProdutoSerieV2({
  branchId,
  start,
  end,
  filtros,
  produto,
  linha,
  enabled = true,
}) {
  const { getCategoryProductTimeseries } = useApiV2();
  const { user } = useAuth();
  const ativo = Boolean(
    enabled && branchId && start && end && produto && linha?.legacy_id != null
  );
  const params = paramsDoDetalhe({ branchId, start, end, filtros, linha });

  const { data, isLoading } = useQuery({
    queryKey: ["produtoSerieV2", user?.user_id ?? null, produto, params],
    queryFn: () => getCategoryProductTimeseries(produto, params),
    enabled: ativo,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });

  return {
    timeseries: data?.timeseries ?? [],
    isLoading: ativo && isLoading,
  };
}
